// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"da9a4508","239":"e699ab94","453":"98d3cffc","455":"0bf96b63"}[chunkId] + ".chunk.js";
};